module.exports = __webpack_public_path__ + "static/details-2-99a82bddfe4d37a2219ab1dd78974069.jpg";